import { FC } from "react";

import { EmailRecipientLabelProps } from "./types";

import { zeffyInputLabelClasses } from "@/dashboard-design-system/InputLabel";
import { DashboardInputLabel } from "@/dashboard-design-system/InputLabel/DashboardInputLabel";
import { useTranslate } from "@/hooks/useTranslate";

export const EmailRecipientLabel: FC<EmailRecipientLabelProps> = ({
  children,
  disabled,
  errorMessage,
  hiddenTitle,
  hiddenHelperText,
  hiddenTooltip,
}) => {
  const { t } = useTranslate();

  return (
    <DashboardInputLabel
      label={hiddenTitle ? undefined : t("dashboard", "tickets.to")}
      helperText={disabled || hiddenHelperText ? "" : t("dashboard", "emailDrawer.recipients.input.helperText")}
      errorMessage={errorMessage}
      tooltipText={hiddenTitle || hiddenTooltip ? undefined : t("dashboard", "emailDrawer.recipients.input.tooltip")}
      sx={(theme) => ({
        [`& .${zeffyInputLabelClasses.helperText}`]: {
          color: theme.palette.text.neutral.quiet,
        },
      })}
    >
      {children}
    </DashboardInputLabel>
  );
};

EmailRecipientLabel.displayName = "EmailRecipientLabel";
